type securityLevelMap = Record<string, string>;

export const securityLevelMapOptions: securityLevelMap = {
    'Admin': 'admin',
    'View': 'view-only',
    'User - NonAdmin': 'user-nonadmin',
}
